import "./forgot-password.component.scss"
import LOGO_MAIN from "../../assets/images/AIDA-power-by-logo.svg";
import LOGO from "../../assets/images/AIDA-logo.svg";
import { useEffect, useState } from "react";
import SENT_IMAGE from "../../assets/images/send-email.png";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import config from "../../config";
import { auth } from "../../firebase/auth.firebase";
import { resetpassword } from "../../services/api.service";
import BG from "../../assets/images/auth-bg.png";
import { useSnackbar } from "../../utility/snackbar.utility";
import CustomSnackbar from "../snackbar/snackbar.component";

const ForgotPasswordComponent = () => {

    const navigate = useNavigate();
    const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();

    const [email, setEmail] = useState<string>("");
    const [errors, setErrors] = useState<{ email?: string; password?: string }>({});
    const [isSent, setIsSent] = useState(false);
    const [isErrorNotFound, setIsErrorNotFound] = useState(false);
    const [disabledSendAgain, setDisabledSendAgain] = useState(false);
    const [countdown, setCountdown] = useState(30);

    useEffect(() => {
        let timer: NodeJS.Timeout | undefined;
        if (disabledSendAgain && countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);
        } else {
            clearInterval(timer);
        }

        return () => clearInterval(timer);
    }, [disabledSendAgain, countdown]);

    // Validation function
    const validateForm = (): boolean => {
        const newErrors: { email?: string; password?: string } = {};

        // Email validation
        if (!email) {
            newErrors.email = "ระบุอีเมล";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = "อีเมลไม่ถูกต้อง";
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChangeEmail = (value) => {
        setEmail(value);
        setIsErrorNotFound(false);
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (disabledSendAgain) return;

        if (validateForm()) {

            try {
                resetpassword(email).then((res: any) => {
                    if (res.success) {
                        setIsSent(true);
                        showSnackbar('ส่งอีเมลตั้งค่ารหัสผ่านใหม่เรียบร้อย');

                        setDisabledSendAgain(true);
                        setCountdown(30);
                        setTimeout(() => setDisabledSendAgain(false), 30000);
                    }
                }).catch((error) => {
                    setIsErrorNotFound(true);
                })
            } catch {
                setIsErrorNotFound(true);
            }


            // handlePasswordReset(auth, email, actionCodeSettings).then((res) => {

            // })

            // Add further submit logic here (e.g., API call)
        }
    };

    const login = () => {
        navigate("/login")
    }
    return (
        <>
            <div className="forgot-password-control">
                <div className="forgot-password-left-control">
                    <img src={BG} className="image-auth-bg" />
                </div>

                <div className="forgot-password-right-control">
                    {
                        isSent ?
                            <>
                                <img src={LOGO} className="forgot-password-logo-top-right"></img>
                                <div className="forgot-password-right-content-control">

                                    <img src={SENT_IMAGE} className="forgot-password-sent-img"></img>
                                    <span className="forgot-password-sent-title">ส่งอีเมลตั้งค่ารหัสผ่านใหม่เรียบร้อย</span>
                                    <span className="forgot-password-sent-desc">ระบบได้ส่งอีเมลตั้งค่ารหัสผ่านใหม่ไปที่อีเมล <strong>{email}</strong>
                                        <br></br>กรุณาตรวจสอบอีเมลเพื่อตั้งค่ารหัสผ่านใหม่</span>
                                    <span className="forgot-password-not-found-email-control">
                                        ไม่พบอีเมล?
                                        <span className={`forgot-password-not-found-email-sent-again ${disabledSendAgain && 'disabled'}`} onClick={handleSubmit}>
                                            ส่งใหม่อีกครั้ง { disabledSendAgain && `(${countdown} วินาที)` }
                                        </span>
                                    </span>

                                    <span className="forgot-password-not-found-email-login" onClick={login}>เข้าสู่ระบบ &gt;</span>

                                </div>
                            </> :
                            <div className="forgot-password-right-content-control">
                                <img src={LOGO_MAIN} className="forgot-password-right-logo"></img>

                                <form onSubmit={handleSubmit} className="forgot-password-right-form-control">

                                    <div className="forgot-form-item-control">
                                        <span className="forgot-password-right-label mt-0">ใส่อีเมลของคุณเพื่อขอรหัสผ่านใหม่</span>
                                        <input
                                            className="forgot-password-form-input"
                                            type="email"
                                            id="email"
                                            placeholder="อีเมล"
                                            value={email}
                                            onChange={(e) => handleChangeEmail(e.target.value)}
                                        />
                                        {errors.email && <p style={{ color: "red", fontSize: "14px" }}>{errors.email}</p>}
                                        {
                                            isErrorNotFound && <p style={{ color: "red", fontSize: "14px" }}>ไม่พบอีเมลในระบบ</p>
                                        }
                                    </div>

                                    <Button
                                        type="submit"
                                        className="forgot-password-submit-button"
                                        onClick={handleSubmit}
                                    >
                                        ตั้งค่ารหัสผ่านใหม่
                                    </Button>
                                </form>

                            </div>
                    }

                </div>
            </div>

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                duration={snackbar.duration}
                onClose={hideSnackbar}
            />
        </>
    )

}

export default ForgotPasswordComponent;